import React from "react";
import Headline from "../components/shared/Headline";
import { Button, Card, Col, notification, Row, Space } from "antd";
import FilterPills from "../widgets/FilterPills";
import PostsApi from "../../api-services/posts-api.service";
import { Blog } from "../../interfaces/blog.interface";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
const { Meta } = Card;

const bannerPath = '/iceholidays-assets/images/blog.png';
const _breadcrumbs = [
  { title: <a href="/web">Home</a> },
  { title: <a href="/web/blog">Blog</a> }
] 

const types = [ {type: "News", label: "News"},{type: "Blogs", label:"Blogs"} ];


export default class BlogPage extends React.Component {
  postsApi = new PostsApi;

  state = {
    blogs: [],
    breadcrumbs: _breadcrumbs,
    searchParamsObj: {type: "", year: "", month: ""},
  }

  componentDidMount() {
    this.postsApi.getBlogs()
      .then(blogsData => {
        this.setState({blogs: blogsData})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading blogs.'});
      });
  }

  setFilter = (selectedFilter) => {
    const {breadcrumbs} = this.state;
    breadcrumbs[2] = {title: this.searchParamsToText()};

    const allHasValues = Object.entries(selectedFilter).every(o => o[1] != "" && o[1] != null);
    if(allHasValues){
      breadcrumbs[1] = {title: <span>Search results</span>};
    }
    this.setState({searchParamsObj: selectedFilter, breadcrumbs})
  }


  searchParamsToText() {
    var {type, year, month} = this.state.searchParamsObj;
    const monthYear = (month || year) && `${month} ${year}`;
    const text = [type, monthYear].filter(val => val).join(", ");
    return <span>{ text } </span>
  }

  render(){
    const {blogs, breadcrumbs, searchParamsObj} = this.state;
    return (
      <div id="blog-page">
        <Headline bannerImage={bannerPath} breadcrumbs={breadcrumbs} title="Blog"/>

        <div id="blog-page_body">
          <Space size={12} direction="vertical">
          <FilterPills items={types} bindValue="type" allOption={true} initialValue={searchParamsObj} selectFilter={(selected)=>this.setFilter(selected)}></FilterPills>
          </Space>

          <div id="blogs">
            <Row wrap gutter={20}>
              {
                blogs.map((blog:Blog) => (
                  <Col key={blog.id} span={8}>
                    <Card cover={<img alt={blog.title} src={blog.thumbnail} />}>
                        <Meta title={blog.title} description={
                          <>
                            {/* <span>{blog.info}</span> */}
                            <div className="preview-content">
                              <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{blog.content}</Markdown>
                            </div>

                            <Button className="view-blog" href={`/web/blog/${blog.id}`} type="link" color="primary" variant="outlined" block>阅读更多</Button>
                          </>
                        } />
                    </Card>
                  </Col>
                ))
              }
            </Row>
          </div>
        </div>
      </div>
    )
  }

}